import { useTranslation } from 'next-i18next';
import { useCallback, useEffect, useRef } from 'react';
import useEditorPanelButtonStore from "../../store/useEditorPanelButtonStore";
import Field from '../Field';
import Modal from '../Modal';

const SignatureModal = () => {
  const { t } = useTranslation(['common', 'convert-and-edit']);
  const ref = useRef(null);

  const store = useEditorPanelButtonStore()

  const handleTextChange = useCallback(($event) => {
    const value = $event.target.value;
    const canvas = ref.current;
    const context = canvas.getContext('2d');
    const x = canvas.width / 2;
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.font = '36px Marck Script';
    context.textAlign = 'center';
    context.fillText(value, x, 50);
  }, []);

  const handleCreateSignature = () => {
    const signature = ref.current.toDataURL('image/png');
    store.setSignatureList([...store.signatureList, signature])
    store.setIsSignatureModalOpen(false)
  }

  useEffect(() => {
    if (ref.current) {
      const canvas = ref.current;
      const context = canvas.getContext('2d');

      const isTouchDevice = 'ontouchstart' in document.documentElement;

      if (isTouchDevice) {
        canvas.addEventListener('touchstart', handleStart, false);
        canvas.addEventListener('touchmove', handleMove, false);
      } else {
        canvas.addEventListener('mousedown', handleStart, false);
        canvas.addEventListener('mousemove', handleMove, false);
      }

      let lastX, lastY;

      function handleStart(event) {
        event.preventDefault();
        lastX = event.pageX - canvas.offsetLeft;
        lastY = event.pageY - canvas.offsetTop;
      }

      function handleMove(event) {
        event.preventDefault();
        let currentX, currentY;

        if (isTouchDevice) {
          currentX = event.touches[0].pageX - canvas.offsetLeft;
          currentY = event.touches[0].pageY - canvas.offsetTop;
        } else {
          if (event.buttons) {
            currentX = event.pageX - canvas.offsetLeft;
            currentY = event.pageY - canvas.offsetTop;
          }
        }

        context.beginPath();
        context.moveTo(lastX, lastY);
        context.lineTo(currentX, currentY);
        context.lineWidth = 2;
        context.strokeStyle = '#111';
        context.stroke();

        lastX = currentX;
        lastY = currentY;
      }

      return () => {
        if (isTouchDevice) {
          canvas.removeEventListener('touchstart', handleStart, false);
          canvas.removeEventListener('touchmove', handleMove, false);
        } else {
          canvas.removeEventListener('mousedown', handleStart, false);
          canvas.removeEventListener('mousemove', handleMove, false);
        }
      };
    }
  });
  return (
    <Modal
      show={store.isSignatureModalOpen}
      className="signature-modal"
      text={t('convert-and-edit:signature-modal.text')}
      cancelButtonProps={{
        onClick: () => store.setIsSignatureModalOpen(false),
      }}
      okButtonProps={{
        onClick: handleCreateSignature,
      }}
    >
      <Field size="md">
        <Field.Input
          type='text'
          placeholder={t('convert-and-edit:signature-modal.placeholder')}
          onKeyUp={handleTextChange}
          autoComplete="off"
        />
      </Field>
      <div className="pdf-editor__signature-canvas">
        <canvas width="320" height="120" ref={ref} />
        <span>{t('convert-and-edit:signature-modal.canvas')}</span>
      </div>
    </Modal>
  );
};
export default SignatureModal;
